import actionTypes from '../constants/action-types';

const dashboardState = {
  chartsData: null,
  fetchingChartData: false,
  summaryData: null,
  partnersSummaryData: null,
  fetchingSummaryData: false,
  selectedQuickLink: null,
  showBannerPreviewModal: false,
  bannerHtml: null,
};

export const dashboardReducer = (state = dashboardState, payload) => {
  switch (payload.type) {
    case actionTypes.HANDLE_SUCCESS_GET_CHART_DATA:
      return { ...state, chartsData: payload.data };
    case actionTypes.HANDLE_FETCHING_CHART_DATA:
      return { ...state, fetchingChartData: payload.data };
    case actionTypes.HANDLE_SUCCESS_GET_SUMMARY_DATA:
      return { ...state, summaryData: payload.data.summary, partnersSummaryData: payload.data.partnersSummary };
    case actionTypes.HANDLE_FETCHING_SUMMARY_DATA:
      return { ...state, fetchingSummaryData: payload.data };
    case actionTypes.HANDLE_QUICK_LINK_CHANGE:
      return { ...state, selectedQuickLink: payload.data };
    case actionTypes.TOGGLE_BANNER_PREVIEW_MODAL:
      return { ...state, showBannerPreviewModal: payload.data.show, bannerHtml: payload.data.bannerHtml };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/main/dashboard/reducers/dashboard-reducer.js